import { Link } from 'react-router-dom';
import { PageWrapper } from '../components/layout/PageWrapper';
import { OrnamentDivider } from '../components/ui/OrnamentDivider';
import { NewsCard } from '../components/news/NewsCard';
import { useNewsList } from '../hooks/useNews';
import { useAuthStore } from '../store/authStore';
import { isFreeAdmin } from '../lib/freeAdmins';
import { Seo } from '../components/Seo';

export function NewsPage() {
  const { data, isLoading } = useNewsList();
  const { user } = useAuthStore();
  const isAdmin = isFreeAdmin(user?.email);

  return (
    <PageWrapper>
      <Seo title="Новости" description="Новости и анонсы клуба спортивной мафии Квинсленда." path="/news" />

      <div className="flex items-end justify-between mb-8">
        <div>
          <p className="font-mono text-xs text-mafia-gold tracking-[0.3em] uppercase mb-3">◆ Клуб ◆</p>
          <h1 className="font-display text-4xl font-bold text-mafia-paper">Новости</h1>
        </div>
        {isAdmin && (
          <Link
            to="/admin/news/new"
            className="btn-gold-solid px-5 py-2.5 text-sm"
          >
            + Добавить новость
          </Link>
        )}
      </div>

      <OrnamentDivider className="mb-10" />

      {isLoading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-mafia-gold border-t-transparent rounded-full animate-spin" />
        </div>
      ) : !data?.items.length ? (
        <p className="text-mafia-paper-dim font-mono text-sm">Новостей пока нет.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.items.map((item) => (
            <NewsCard key={item.newsId} item={item} />
          ))}
        </div>
      )}
    </PageWrapper>
  );
}
